import { defineStyle } from '@chakra-ui/react';

export const replayVariant = defineStyle({
  height: '110px',
  width: '48px',
  backgroundColor: 'neutral.900',
  color: 'neutral.white',
  _hover: {
    backgroundColor: 'neutral.700',
    _disabled: {
      backgroundColor: 'neutral.900',
    },
  },
});
